import React, { useState } from 'react'
import { Link } from 'react-router-dom'

// Sign-up form - left
// login form - right

const LogIn = () => {
    // slider states here
    const [active, setActive] = useState(false)
    const [forgotPass, setForgotPass] = useState(false)

    // function to stop PHP form submission
    const handleForm = (event) => {
        event.preventDefault()
    }

    // Function to reset all states
    const resetState = () => {
        setForgotPass(false)
        setActive(false)
    }

  return (
    <>
        <section className='login'>
            <div className="container login-container">
                <h3 className="section-subtitle">AutoInsure</h3>
                <h1 className="section-title">Log In/Sign Up</h1>
                <p className="section-caption">Log Into your account, or Create An Account here.</p>
                <div className="login-box">
                    <div className="login-img-slide">
                        <div className="register-overlay">
                            <h2 className="register-title">Create Account</h2>
                            <button className="btn btn-lg btn-light register-btn" onClick={() => setActive(true)}>Register</button>
                        </div>
                        <div className="login-overlay">
                            <h2 className="login-title">Have an Account?</h2>
                            <button className="btn btn-lg btn-light register-btn" onClick={() => setActive(false)}>Log In</button>
                        </div>
                        <div className={`form-container ${active ? "signup-active" : "login-active"}`}>
                            <div className={`register-form-container ${active ? "show-form" : "hide-form"}`}>
                                <h2 className="register-form-title">Sign Up</h2>
                                <form onSubmit={handleForm} className='reg-form'>
                                    <div className="form-group">
                                        <label htmlFor="reg-f-name" className='reg-f-name-label'>First Name*</label>
                                        <input type="text" name='reg-f-name' className='reg-f-name-input'/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="reg-l-name" className='reg-l-name-label'>Last Name*</label>
                                        <input type="text" name='reg-l-name' className='reg-l-name-input'/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="reg-email" className='reg-email-label'>Email*</label>
                                        <input type="text" name='reg-email' className='reg-email-input'/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="reg-password" className='reg-password-label'>Password*</label>
                                        <input type="password" name='reg-password' className='reg-password-input'/>
                                    </div>
                                    <button className="btn btn-md btn-light register-btn">Register</button>
                                    <div className="login-extra">
                                        <Link to="">
                                            <span className="login-link" onClick={() => setActive(false)}>Log In</span>
                                        </Link>
                                        |
                                        <Link to="">
                                            <span className="forgot-password">Our Privacy Policy</span>
                                        </Link>
                                    </div>
                                </form>
                            </div>
                            <div className={`login-form-container ${active || forgotPass ? "hide-form" : "show-form"}`}>
                                <h2 className="login-form-title">Log In</h2>
                                <form onSubmit={handleForm} className='login-form'>
                                    <div className="form-group">
                                        <label htmlFor="login-email" className='login-email-label'>Email*</label>
                                        <input type="text" name='login-email' className='login-email-input'/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="login-password" className='login-password-label'>Password*</label>
                                        <input type="password" name='login-password' className='login-password-input'/>
                                    </div>
                                    <button className="btn btn-md btn-light login-btn">Log In</button>
                                    <div className="register-extra">
                                        <Link to="">
                                            <span className="signup-link" onClick={() => setActive(true)}>Sign Up</span>
                                        </Link>
                                        |
                                        <Link to="">
                                            <span className="forgot-password" onClick={() => setForgotPass(true)}>Forgot your Password?</span>
                                        </Link>
                                    </div>
                                </form>
                            </div>
                            <div className={`login-form-container password-form ${forgotPass ? "show-password-form" : "hide-form"}`}>
                                <h2 className="login-form-title">Lost Your Password?</h2>
                                <p className="forgot-password-caption">Enter your email below, you will receive a link to create a new password via email.</p>
                                <form onSubmit={handleForm} className='login-form'>
                                    <div className="form-group">
                                        <input type="email" name='forgot-password-input' placeholder='email address...' className='password-one-input'/>
                                    </div>
                                    <button className="btn btn-md btn-light reset-password" onClick={() => alert("A message has been sent to your email address with instructions to reset your password.")}>Reset Password</button>
                                    <div className="register-extra">
                                        <Link to="">
                                            <span className="signup-link" onClick={() => setForgotPass(false)}>Sign Up</span>
                                        </Link>
                                        |
                                        <Link to="">
                                            <span className="login-link" onClick={resetState}>Log In</span>
                                        </Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default LogIn